import { QUERY_KEYS } from "@app/dashboard/constants/query-keys";
import { getTotalSales } from "@app/dashboard/services/inner_layout/home/charts";
import type { IHomeApisParams } from "@app/dashboard/types/innerLayout/home";
import Line from "../lineChart";

const TotalSales = (
  { apiParams, timeFormat, rangeType }
    :
    { apiParams: IHomeApisParams, timeFormat: string, rangeType: string }
) => {
  return (
    <Line
      apiParams={apiParams}
      timeFormat={timeFormat}
      rangeType={rangeType}
      queryKey={QUERY_KEYS.GET_TOTAL_SALES}
      queryFn={getTotalSales}
    />
  )
}

export default TotalSales;